// contexts/ResetPasswordContext.jsx
import React, { createContext, useContext } from "react";
import { BASE_URL } from "../config/config";

const ResetPasswordContext = createContext();

export const useResetPassword = () => useContext(ResetPasswordContext);

export const ResetPasswordProvider = ({ children }) => {
  const resetPassword = async ({ email, token, password }) => {
    try {
      const response = await fetch(`${BASE_URL}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, token, password })
      });

      const data = await response.json();
      console.log(data);
      return data;
    } catch (error) {
      return {
        status: 500,
        message: "Network error. Please try again later."
      };
    }
  };

  return (
    <ResetPasswordContext.Provider value={{ resetPassword }}>
      {children}
    </ResetPasswordContext.Provider>
  );
};
